import {
  MOCK_WIDGET_LOGIN,
  type WidgetLoginRequest,
  type WidgetLoginResponse,
} from '@teo/widget-shared';
import type { ScriptTagConfig } from '../config/parse-script-config.js';

const WIDGET_LOGIN_PATH = '/api/widget';

export function buildWidgetLoginUrl(
  apiBase: string,
  slug: string,
): string {
  const base = apiBase.replace(/\/$/, '');
  return `${base}${WIDGET_LOGIN_PATH}/${slug}/login`;
}

export async function widgetLogin(
  config: ScriptTagConfig,
  visitorId: string,
): Promise<WidgetLoginResponse> {
  if (config.mock) {
    return MOCK_WIDGET_LOGIN;
  }

  if (!config.slug) {
    throw new Error('[Teo Widget] data-slug is required for login');
  }

  const url = buildWidgetLoginUrl(
    config.apiBase || window.location.origin,
    config.slug,
  );

  const body: WidgetLoginRequest = { visitor_id: visitorId };

  const response = await fetch(url, {
    method: 'POST',
    credentials: 'omit',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`[Teo Widget] Login failed (${response.status})`);
  }

  return response.json() as Promise<WidgetLoginResponse>;
}
